export default "__VITE_ASSET__CCT2BViE__"